<template>
  <v-row align="center" class="font-weight-medium" style="flex-wrap: nowrap">
    <v-dialog
      v-model="showManageAlert"
      max-width="480px"
    >
      <videon-card :heading="alert.label" showClose="true" @close="showManageAlert = false">
        <v-card-text>
          <div class="ma-1">
            <v-row>
              <videon-state-tile
                heading="Device"
              >
                <device-label :device="$devices.getDevice(alert.device_guid)" class="ma-3" />
              </videon-state-tile>
              <videon-state-tile
                heading="Condition"
                v-if="alert.alert_type == 'device'"
              >
                {{ $helpers.deviceAlertCondition(alert) }}
              </videon-state-tile>
              <videon-state-tile
                heading="Condition"
                v-else
              >
                {{ $helpers.alertCondition(alert) }}
              </videon-state-tile>
            </v-row>
            <v-row class="mt-2">
              <videon-state-tile
                heading="Created"
              >
                {{ alert.timestamp | moment("YYYY/MM/DD hh:mm:ss a") }}
              </videon-state-tile>
            </v-row>
          
            <v-row><h5 class="text--disabled">State</h5></v-row>
            <v-row><v-divider /></v-row>
            <v-row>
              <videon-state-tile
                heading="Resolved"
              >
                {{ (alert.resolved) ? 'Yes' : 'No' }}
              </videon-state-tile>
              <videon-state-tile
                heading="Silenced"
              >
                {{ (alert.silenced) ? 'Yes' : 'No' }}
              </videon-state-tile>
            </v-row>
            
            <v-row v-if="alert.silenced">
              <videon-state-tile
                heading="Silenced At"
              >
                {{ alert.silenced_timestamp | moment("YYYY/MM/DD hh:mm:ss a") }}
              </videon-state-tile>
              <videon-state-tile
                heading="Silenced By"
              >
                <user-label :user="$users.getUser(alert.silenced_toggled_by)" class="ma-3" />
              </videon-state-tile>
            </v-row>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-row
             align="center"
             justify="end"
             class="ma-2 mt-0"
           >
             <v-tooltip 
               v-if="!alert.silenced"
               top
              >
               <template #activator="{ on }">
                 <v-btn
                   v-on="on"
                   color="secondary"
                   @click="silenceAlert(alert)"
                   class="ma-1"
                   outlined
                   :disabled="!canEdit || alert.resolved"
                 >
                   Silence
                 </v-btn>
                </template>
                <span>Silencing alerts stops them from notifying again until they are closed.</span>
             </v-tooltip>
             <v-btn
               v-else
               color="secondary"
               @click="silenceAlert(alert, false)"
               class="ma-1"
               outlined
               :disabled="!canEdit || alert.resolved"
             >
               Unsilence
             </v-btn>
             <v-tooltip top>
               <template #activator="{ on }">
                 <v-btn
                   v-on="on"
                   color="primary"
                   @click="deleteAlert(alert)"
                   class="ma-1"
                   :disabled="!canEdit"
                 >
                   Close Alert
                 </v-btn>
               </template>
               <span>Closing an alert will allow a new notification to be generated if the condition arises again.</span>
            </v-tooltip>
          </v-row>
        </v-card-actions>
      </videon-card>
    </v-dialog>
    
    <v-icon class="mr-1" :color="iconColor">{{ icon }}</v-icon>
    <span class="mr-1" @click="showManageAlert = true" style="cursor: pointer;" @click.stop.prevent>{{ label }}</span>
  </v-row>
</template>

<script>
  import { mapGetters } from 'vuex'
  
  export default {
    name: 'AlertStateLabel',
    props: ['alert', 'dark'],
    
    data() {
      return {
        error: false,
        errorText: '',
        
        showManageAlert: false,
      }
    },
    
    computed: {
      ...mapGetters('user', ['organization']),
      
      icon() {
        if (this.alert.resolved) {
          return 'check'
        }
        return 'warning'
      },
      
      iconColor() {
        if (this.dark) {
          return 'white'
        } else if (this.alert.resolved) {
          return 'green'
        } else if (this.alert.silenced) {
          return 'grey'
        } else 
        
        return 'red'
      },
      
      label() {
        if (!this.alert.resolved && !this.alert.silenced) {
          return 'Unresolved'
        } else if (!this.alert.resolved && this.alert.silenced) {
          return 'Silenced'
        } else if (this.alert.resolved) {
          return 'Resolved'
        }
        return 'Unknown'
      },
      
      canEdit() {
        return this.$devices.getDevice(this.alert.device_guid).canEdit()
      }
    },
    methods: {
      silenceAlert(item, silence = true) {
        console.log('AlertStateLabel silenceAlert', item)
        this.showManageAlert = false
        
        if (item.alert_type == 'device') {
          this.axios.patch('/device_alerts/' + item.device_guid + '?alert_guid=' + item.alert_guid, { 'silenced': silence })
          .then((response) => {
            console.log('AlertStateLabel silenceAlert', response)
          
            if (this.organization && this.organization.org_guid) {
              this.$alerts.getAlerts(this.organization.org_guid)
            }
          }).catch((error) => {
            console.log('AlertStateLabel silenceAlert error', error)
        
            this.error = true
            this.errorText = this.$helpers.parseError(error)
          })
        } else {
          this.axios.patch('/alerts/' + item.alert_guid, { 'silenced': silence })
          .then((response) => {
            console.log('AlertStateLabel silenceAlert', response)
          
            if (this.organization && this.organization.org_guid) {
              this.$alerts.getAlerts(this.organization.org_guid)
            }
          }).catch((error) => {
            console.log('AlertStateLabel silenceAlert error', error)
        
            this.error = true
            this.errorText = this.$helpers.parseError(error)
          })
        }
      },
      
      deleteAlert(item) {
        console.log('AlertListing deleteAlert', item)
        this.showManageAlert = false
        
        if (item.alert_type == 'device') {
          this.axios.delete('/device_alerts/' + item.device_guid + '?alert_guid=' + item.alert_guid)
          .then((response) => {
            console.log('AlertStateLabel deleteAlert', response)
          
            if (this.organization && this.organization.org_guid) {
              this.$alerts.getAlerts(this.organization.org_guid)
            }
          }).catch((error) => {
            console.log('AlertStateLabel deleteAlert error', error)
        
            this.error = true
            this.errorText = this.$helpers.parseError(error)
          })
        } else {
          this.axios.delete('/alerts/' + item.alert_guid)
          .then((response) => {
            console.log('AlertStateLabel deleteAlert', response)
          
            if (this.organization && this.organization.org_guid) {
              this.$alerts.getAlerts(this.organization.org_guid)
            }
          }).catch((error) => {
            console.log('AlertStateLabel deleteAlert error', error)
        
            this.error = true
            this.errorText = this.$helpers.parseError(error)
          })
        }
      }
    }
  }
</script>